import React from 'react';

const CreationModal = ({ 
  isCreating, 
  setIsCreating, 
  newCompetition, 
  handleCreateInputChange,
  handleCreateCompetition,
  categories
}) => {
  const onSubmit = (e) => {
    e.preventDefault();
    handleCreateCompetition(e);
  };

  // Define competition categories - replaced 'music' with 'artist' and 'song'
  const competitionCategories = categories || ['club', 'player', 'coach', 'model', 'artist', 'song'];

  // Helper function to format category names for display
  const formatCategoryName = (category) => {
    const categoryMap = {
      'player': 'Player',
      'club': 'Club',
      'coach': 'Coach',
      'model': 'Lifestyle Model',
      'artist': 'Artist',
      'song': 'Song'
    };
    return categoryMap[category] || category.charAt(0).toUpperCase() + category.slice(1);
  };

  // Helper function to get category description
  const getCategoryDescription = (category) => {
    const descriptions = {
      'player': 'Competition for athletes/players',
      'club': 'Competition for clubs/teams',
      'coach': 'Competition for coaches',
      'model': 'Competition for lifestyle models',
      'artist': 'Competition for music artists',
      'song': 'Competition for individual songs'
    };
    return descriptions[category] || '';
  };

  return (
    <div className="fixed inset-0 z-50 bg-black/70 flex items-center justify-center p-4">
      <div className="bg-surface-800 border border-line-strong rounded-xl w-full max-w-2xl max-h-[90vh] overflow-y-auto shadow-2xl">
        <div className="px-6 py-4 border-b border-line">
          <h2 className="text-lg font-semibold text-white">Create New Competition</h2>
        </div>
        <form onSubmit={onSubmit} className="p-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
            <div className="md:col-span-2">
              <label className="field-label">Title *</label>
              <input
                type="text"
                name="title"
                value={newCompetition.title}
                onChange={handleCreateInputChange}
                className="field"
                placeholder="Enter competition title"
                required
              />
            </div>

            <div className="md:col-span-2">
              <label className="field-label">Description</label>
              <textarea
                name="description"
                value={newCompetition.description}
                onChange={handleCreateInputChange}
                className="field min-h-[96px]"
                placeholder="Enter competition description"
              />
            </div>

            <div>
              <label className="field-label">Start date *</label>
              <input
                type="date"
                name="startDate"
                value={newCompetition.startDate}
                onChange={handleCreateInputChange}
                className="field"
                required
              />
            </div>

            <div>
              <label className="field-label">End date *</label>
              <input
                type="date"
                name="endDate"
                value={newCompetition.endDate}
                onChange={handleCreateInputChange}
                className="field"
                required
              />
            </div>

            <div>
              <label className="field-label">Status *</label>
              <select
                name="status"
                value={newCompetition.status}
                onChange={handleCreateInputChange}
                className="field"
              >
                <option value="draft">Draft</option>
                <option value="active">Active</option>
                <option value="completed">Completed</option>
              </select>
            </div>

            <div>
              <label className="field-label">Category *</label>
              <select
                name="category"
                value={newCompetition.category}
                onChange={handleCreateInputChange}
                className="field"
                required
              >
                <option value="">Select category</option>
                {competitionCategories.map(cat => (
                  <option key={cat} value={cat} title={getCategoryDescription(cat)}>
                    {formatCategoryName(cat)}
                  </option>
                ))}
              </select>
            </div>

            {newCompetition.category && (
              <div className="md:col-span-2 panel p-3">
                <p className="text-sm text-gray-300">
                  <span className="font-medium text-accent-soft">Note:</span>{' '}
                  You'll be able to add {newCompetition.category === 'artist' ? 'artists' : 
                                        newCompetition.category === 'song' ? 'songs' : 
                                        newCompetition.category === 'model' ? 'lifestyle models' : 
                                        `${newCompetition.category}s`} as participants after creation.
                </p>
                {newCompetition.category === 'song' && (
                  <p className="text-xs text-gray-500 mt-1">
                    Songs will be displayed with their artist names and can compete in categories like "Song of the Year", "Best Lyrics", etc.
                  </p>
                )}
                {newCompetition.category === 'artist' && (
                  <p className="text-xs text-gray-500 mt-1">
                    Artists can compete in categories like "Best Artist", "Most Popular", "Rising Star", etc.
                  </p>
                )}
                {newCompetition.category === 'model' && (
                  <p className="text-xs text-gray-500 mt-1">
                    Models can compete in categories like "Best Photoshoot", "Most Stylish", "Fan Favorite", etc.
                  </p>
                )}
              </div>
            )}
          </div>

          <div className="mt-6 flex justify-end gap-2">
            <button
              type="button"
              onClick={() => setIsCreating(false)}
              className="btn-secondary"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="btn-primary"
            >
              Create competition
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreationModal;